import React from "react";
import { formatKM, formatMoney } from "@/lib/format";
import { computePorijeklo, pct } from "@/lib/porijeklo";

function Tile({ label, value, accent, testid }) {
  return (
    <div className="rounded-xl border bg-card p-4">
      <div className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">{label}</div>
      <div className={`text-lg font-extrabold font-heading tabular-nums mt-1 ${accent || ""}`} data-testid={testid}>{value}</div>
    </div>
  );
}

export default function PorijekloSummary({ doc }) {
  const c = computePorijeklo(doc);
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-3" data-testid="porijeklo-summary">
      <Tile label="Sa porijeklom" value={formatKM(c.totSa)} accent="text-red-600" testid="porijeklo-tot-sa" />
      <Tile label="Bez porijekla" value={formatKM(c.totBez)} testid="porijeklo-tot-bez" />
      <Tile label="Ukupno materijal" value={formatKM(c.total)} testid="porijeklo-total" />
      <Tile label="FCA fabrika" value={`${formatMoney(c.fcaEur, "EUR")} = ${formatKM(c.fcaKm)}`} testid="porijeklo-fca" />
      <Tile label="Bez porijekla / FCA" value={pct(c.ratio)} accent="text-emerald-700 dark:text-emerald-400" testid="porijeklo-ratio" />
    </div>
  );
}
